import React from "react";
import { Modal } from "react-blueprint-library";
import { isSafari } from "../../../../common/Functions";

const bodyStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "45px",
  padding: "32px 32px 0 32px",
};

const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const DocConfirmationModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      title="Download Files"
      id="downloadModal"
      show={isOpen}
      className={isSafari ? "modal-md safari-only-wrapper" : "modal-md"}
      centered
    >
      <div style={{ padding: ".2rem" }}>
        <div className="modal-body">
          <div className="row" style={bodyStyle}>
            <div className="col-md-12" style={headerStyle}>
              <div>
                <h2 style={{ color: "#000", margin: 0 }}>Thank you!</h2>
              </div>
              <div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close modal dialog"
                  onClick={onClose}
                  style={{ margin: 0, padding: 0 }}
                />
              </div>
            </div>
          </div>
          <main>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: 8,
                padding: "0 32px 32px 32px",
              }}
            >
              <div
                style={{
                  width: 416,
                  color: "black",
                  fontSize: 16,
                  fontFamily: "Lato, sans-serif",
                  fontWeight: 700,
                  lineHeight: "24px",
                  wordWrap: "break-word",
                }}
              >
                Your document(s) were submitted.
              </div>
              <div
                style={{
                  maxWidth: 416,
                  color: "black",
                  fontSize: 16,
                  fontFamily: "Lato, sans-serif",
                  fontWeight: 400,
                  lineHeight: "24px",
                  wordWrap: "break-word",
                }}
              >
                Your agency coordinator will review your documents and contact
                you if more information is needed.
              </div>
            </div>
          </main>
        </div>
      </div>
    </Modal>
  );
};

export default DocConfirmationModal;
